"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _uniformsMaterial = require("uniforms-material");

var _reactI18next = require("react-i18next");

var _forgottenPassSchema = _interopRequireDefault(require("./forgottenPassSchema"));

var _DefaultSubmitField = _interopRequireDefault(require("../DefaultSubmitField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ForgottenPassForm = function ForgottenPassForm(_ref) {
  var header = _ref.header,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      model = _ref.model,
      createValidator = _ref.createValidator,
      customErrors = _ref.customErrors;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  return _react.default.createElement("div", null, _react.default.createElement(_core.Typography, {
    variant: "h4",
    gutterBottom: true
  }, header || t('Please login!')), _react.default.createElement(_uniformsMaterial.AutoForm, {
    schema: (0, _forgottenPassSchema.default)({
      i18n: i18n,
      createValidator: createValidator
    }),
    onSubmit: onSubmit,
    onChange: onChange,
    model: model
  }, _react.default.createElement(_uniformsMaterial.AutoField, {
    name: 'email'
  }), _react.default.createElement(_uniformsMaterial.ErrorField, {
    name: 'email',
    errorMessage: customErrors && customErrors['email'] || t('Must be an valid email address!')
  }), _react.default.createElement(_DefaultSubmitField.default, {
    label: t('REMIND')
  })));
};

ForgottenPassForm.propTypes = {
  header: _propTypes.default.string,
  model: _propTypes.default.object,
  customErrors: _propTypes.default.object,
  onChange: _propTypes.default.func,
  onSubmit: _propTypes.default.func.isRequired,
  createValidator: _propTypes.default.func.isRequired
};
var _default = ForgottenPassForm;
exports.default = _default;